var map = {
	"./bulky.svg": "ef7c",
	"./gardens.svg": "7aeb",
	"./kitchen.svg": "5851",
	"./other.svg": "7b2c",
	"./particles.svg": "b4e0",
	"./site.svg": "556d",
	"./statistics.svg": "7e06"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";